import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const LEARN_MORE_URL = 'https://help.benchling.com/hc/en-us/articles/45766024411405-Use-Benchling-AI-chat';
/**
 * Banner warning that legacy AI agents (Ask, Deep Research, Compose, Analysis) may be deprecated in
 * a future release, and nudging users toward Chat (the unified Assistant) instead.
 *
 * Shown at the top of the AI chat panel when a legacy agent is active, and in the tenant admin AI
 * Settings under the "Legacy agents" toggle.
 */
export default function LegacyAgentDeprecationBanner(): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      supportingInfo={
        <span>
          Starting <strong>July 29</strong>, legacy agents will be retired.{' '}
          <strong>Benchling AI Chat </strong>
          brings all the capabilities of legacy agents into one chat experience.{' '}
          <a
            {...getTestProps({component: 'LegacyAgentDeprecationBanner', element: 'learnMoreLink'})}
            href={LEARN_MORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>Learn more</strong> <BenchlingIcon icon="arrow-up-right-from-square" />
          </a>
        </span>
      }
      dataTestAttrs={{component: 'LegacyAgentDeprecationBanner', element: 'root'}}
    />
  );
}
